import { ForwardedRef, forwardRef } from 'react';
import * as Styles from './JobSearch.styles';
import JobSearchList, { JobSearchListType } from '../JobSearchList';
import SearchInput, { SearchInputType } from '../SearchInput';

type JobSearchContainerType = {
  isJobSearchListVisible: boolean;
};
type JobSearchType = JobSearchListType & SearchInputType & JobSearchContainerType;

const JobSearchComponent = (
  {
    jobs,
    value,
    isLoading,
    hasError,
    hasFetched,
    onChangeHandler,
    containerRef,
    isJobSearchListVisible,
    ...props
  }: JobSearchType,
  ref: ForwardedRef<HTMLInputElement>
): JSX.Element => (
  <Styles.Box {...props}>
    <SearchInput ref={ref} value={value} onChangeHandler={onChangeHandler} />

    {isJobSearchListVisible && (
      <JobSearchList
        containerRef={containerRef}
        jobs={jobs}
        isLoading={isLoading}
        hasError={hasError}
        hasFetched={hasFetched}
      />
    )}
  </Styles.Box>
);

export default forwardRef(JobSearchComponent);
